module.exports = __webpack_public_path__ + "img/info-file-text.a7dab903.svg";